import { Component, HostListener, inject } from '@angular/core';
import { UploadsService } from '../../services/uploads.service';
import { UploadItem } from '../../interfaces/components/upload-item.interface';

@Component({
  selector: 'app-uploads-tray',
  standalone: true,
  templateUrl: './uploads-tray.component.html',
  styleUrl: './uploads-tray.component.scss',
})
export class UploadsTrayComponent {
  private readonly uploadsService = inject(UploadsService);

  readonly uploads = this.uploadsService.uploads;

  /** Uploads are lost if the tab is closed or refreshed, so ask the browser to confirm. */
  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    if (this.uploadsService.hasActiveUploads()) {
      event.preventDefault();
    }
  }

  percent(upload: UploadItem): number {
    return upload.totalBytes > 0 ? Math.min(100, Math.round((upload.loadedBytes / upload.totalBytes) * 100)) : 0;
  }

  statusLabel(upload: UploadItem): string {
    switch (upload.status) {
      case 'completed':
        return 'Uploaded';
      case 'failed':
        return 'Upload failed';
      default:
        return `${this.percent(upload)}% of ${this.formatBytes(upload.totalBytes)}`;
    }
  }

  dismiss(id: string): void {
    this.uploadsService.dismiss(id);
  }

  private formatBytes(bytes: number): string {
    if (bytes >= 1024 ** 3) {
      return `${(bytes / 1024 ** 3).toFixed(2)} GB`;
    }
    if (bytes >= 1024 ** 2) {
      return `${(bytes / 1024 ** 2).toFixed(1)} MB`;
    }
    return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  }
}
